import axios from 'axios';

const SERVICE_URL_WORKFLOW = '/workflow/';
const RECEIVE_WORKFLOWS = 'RECEIVE_WORKFLOWS';

const state = {
  workflows: [],
};

const getters = {
  workflows: state => state.workflows,
};

const actions = {
  getWorkflows({
    commit,
  }) {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    };
    return axios.get(SERVICE_URL_WORKFLOW, config)
      .then((response) => {
        commit(RECEIVE_WORKFLOWS, response.data);
      })
      .catch((error) => {
        if (error) {
          console.log(error);
        }
      });
  },
  saveWorkflow({
    commit,
  }, nuevo) {
    return new Promise((resolve) => {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      };
      axios.post(`${SERVICE_URL_WORKFLOW}crear`, nuevo, config)
        .then((response) => {
          if (!response.data.success) {
            resolve(response.data.message);
          } else {
            resolve(true);
          }
        });
    });
  },
};

const mutations = {
  [RECEIVE_WORKFLOWS](state, workflows) {
    state.workflows = workflows;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};